var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "perks-widget__offers" }, [
    _c("h2", [_vm._v("Offers")]),
    _vm._v(" "),
    _vm.offers && _vm.offers.length
      ? _c(
          "div",
          { staticClass: "offer-list" },
          _vm._l(_vm.offers, function (offerGroup) {
            return _c(
              "div",
              {
                key: offerGroup.vendor.vend_id,
                staticClass: "offer-list__item",
              },
              [
                _c("div", { staticClass: "perks-widget__box" }, [
                  offerGroup.vendor.logo
                    ? _c("div", [
                        _c("img", {
                          staticClass: "img--natural",
                          attrs: { src: offerGroup.vendor.logo.url },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h3", [_vm._v(_vm._s(offerGroup.vendor.v_name))]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    _vm._l(offerGroup.offers, function (offer) {
                      return _c("li", { key: offer.id }, [
                        _c("a", {
                          attrs: {
                            href:
                              "https://demo.abenity.com/discounts/offer/" +
                              offer.provider_id +
                              ":" +
                              offer.provider_offer_id,
                            rel: "noopener noreferrer",
                            target: "_blank",
                          },
                          domProps: { innerHTML: _vm._s(offer.offer_title) },
                        }),
                      ])
                    }),
                    0
                  ),
                ]),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }